export default __webpack_public_path__ + "static/media/lc.1ef20b6d.svg";